import * as React from 'react';
import classNames from 'classnames';
import './Tag.scss';
import { useTooltip } from '../CustomTooltip';

export interface ITagProps {
  className?: string;
  children?: any;
  size?: 'mini' | 'small';
  color?: 'danger' | 'success' | 'warning' | 'gray' | 'info' | 'cancelled' | 'white' | 'dark-blue';
  rounded?: boolean;
  tooltip?: string;
}

const Tag = ({
  className,
  size,
  color,
  rounded,
  tooltip,
  children
}: ITagProps) => (
  <span
    className={classNames(
      'tag',
      'relative',
      size ? `is-${size}` : 'is-small',
      color ? `is-${color}` : 'is-gray',
      rounded && 'is-rounded',
      className
    )}
    {...useTooltip(tooltip)}
  >
    {children}
  </span>
);

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag/index.tsx